import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 40,
    height: 20,
    padding: 0,
    display: "flex",
    borderRadius: 25,
    marginLeft: "auto",
  },
  switchBase: {
    padding: 2,
 /*    transition: "all 0.5s", */
    color: theme.palette.grey[500],
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        opacity: 1,
        backgroundColor: "#209cc8",
        borderColor: "#209cc8",
      },
    },
  },
  thumb: {
    width: 15,
    height: 15,
    boxShadow: "none",
    transform: "translateX(3px)",
  },
  track: {
/*     border: `1px solid #3f414c`, */
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "#3f414c",
  },
  checked: {},
}))(Switch);

export default function JirangoSwitch({ onChange, isChecked }) {
  return (
    <AntSwitch checked={isChecked} onChange={onChange} />
    /*   <AppSwitch onChange={onChange} checked={isChecked} className={'mx-1 switch-sm jirango-switch'} variant={'3d'} color={'success'} /> */
  );
}
